@if (showQuestionResponseDistribution) {
    <h3 class="mb-3">{{ surveyQuestion }}</h3>
    <adapt-display-question-response-distribution [survey]="survey$ | async"
                                                  [maxResponseCount]="maxResponseCount"
                                                  (maxResponseCountChange)="maxResponseCountChange.emit($event)"
                                                  [surveyQuestions]="surveyQuestions"
                                                  [questionId]="questionId"></adapt-display-question-response-distribution>
}
@if (!isInitialised) {
    <!-- <div [ngClass]="presentResponseGroups.length === 1 ? 'gauge-placeholder-without-header' : 'gauge-placeholder-with-header'"></div> -->
    <div class="gauge-placeholder"></div>
} @else {
    <div class="d-flex flex-row justify-content-between">
        @for (group of presentResponseGroups; track group) {
            @if ($any(groupStats)[group]; as stats) {
                <div class="d-flex flex-column align-items-center realign-for-print"
                     [ngClass]="presentResponseGroups.length === 1 ? 'w-100' : 'w-50'">
                    @if (stats) {
                        <dx-linear-gauge class="question-stats"
                                         [value]="stats!.average"
                                         [subvalues]="[stats!.min, stats!.max]"
                                         (onInitialized)="onInitialized($event)"
                                         (onDrawn)="isDrawn = true"
                                         (onDisposing)="onDisposing($event)">
                            <dxo-animation [enabled]="false"></dxo-animation>
                            @if (!showQuestionResponseDistribution) {
                                <dxo-size [height]="60"></dxo-size>
                            }
                            @if (getStatusColorFromPercentage) {
                                <dxo-value-indicator type="textCloud"
                                                     [offset]="-5"
                                                     [color]="getStatusColorFromPercentage!(stats!.average)">
                                    <dxo-text [customizeText]="customiseScaleText">
                                        <dxo-font [size]="12"></dxo-font>
                                    </dxo-text>
                                </dxo-value-indicator>
                            }
                            <dxo-range-container>
                                @for (range of gaugeRanges; track range) {
                                    <dxi-range [color]="range.color"
                                               [startValue]="range.startValue"
                                               [endValue]="range.endValue"></dxi-range>
                                }
                            </dxo-range-container>
                            <dxo-scale [startValue]="0"
                                       [endValue]="100"
                                       [customTicks]="tickValues">
                                <dxo-label [indentFromTick]="5"
                                           [customizeText]="customiseScaleText">
                                    <dxo-font [size]="10"></dxo-font>
                                </dxo-label>
                            </dxo-scale>
                            @if (showQuestionResponseDistribution) {
                                <dxo-title text="Question average"
                                           verticalAlignment="bottom">
                                    <dxo-font [size]="16"></dxo-font>
                                </dxo-title>
                            }
                            <dxo-tooltip [enabled]="true"
                                         [customizeTooltip]="customiseChartTooltip"></dxo-tooltip>
                        </dx-linear-gauge>
                    }
                    @if (presentResponseGroups.length > 1 && !isXL) {
                        <span class="response-group-header">{{ $any(GroupLabel)[group] }}</span>
                    }
                </div>
            }
        }
    </div>
}
